var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66634 7.45065H10.333V6.45065H3.66634V7.45065ZM6.99967 13.6673C6.08856 13.6673 5.22745 13.4923 4.41634 13.1423C3.60523 12.7923 2.8969 12.3145 2.29134 11.709C1.68579 11.1034 1.20801 10.3951 0.858008 9.58398C0.508008 8.77287 0.333008 7.91176 0.333008 7.00065C0.333008 6.07843 0.508008 5.21176 0.858008 4.40065C1.20801 3.58954 1.68579 2.88398 2.29134 2.28398C2.8969 1.68398 3.60523 1.20898 4.41634 0.858984C5.22745 0.508984 6.08856 0.333984 6.99967 0.333984C7.9219 0.333984 8.78856 0.508984 9.59967 0.858984C10.4108 1.20898 11.1163 1.68398 11.7163 2.28398C12.3163 2.88398 12.7913 3.58954 13.1413 4.40065C13.4913 5.21176 13.6663 6.07843 13.6663 7.00065C13.6663 7.91176 13.4913 8.77287 13.1413 9.58398C12.7913 10.3951 12.3163 11.1034 11.7163 11.709C11.1163 12.3145 10.4108 12.7923 9.59967 13.1423C8.78856 13.4923 7.9219 13.6673 6.99967 13.6673Z",
    fill: "#D80027"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.d64a90450e155032662c8efda3d83901.svg";
export { ForwardRef as ReactComponent };